export const REQUEST_LOGIN = "REQUEST_LOGIN";
export const TOKEN_RECEIVED = "TOKEN_RECEIVED";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT = "LOGOUT";
